module.exports = __webpack_public_path__ + "static/media/flag-id.efe8b306.svg";